import React from "react";
import { useHistory } from "react-router-dom";
import DataTable from "../core/ui/data-table";
import FormatDateTime from "../core/utils/FormatDateTime";

export default function AdminAuditLogs() {
  const history = useHistory();

  const table_columns = [
    { header: "First Name", key: "first_name", render: (val) => val.user.first_name },
    { header: "Last Name", key: "last_name", render: (val) => val.user.last_name },
    { header: "Action", key: "action" },
    { header: "Function", key: "function" },
    { header: "Modified ID", key: "modified_id" },
    { header: "Timestamp", key: "timestamp", render: (val) => <FormatDateTime date={val.timestamp} /> },
  ];

// TODO: when we are ready to display more details we can use a modal triggered from here
//   const table_actions = (log) => {
//     const onClickView = () => {
//       console.log('log', log)
//     }
//     return (
//       <div className="" onClick={onClickView}> <i className="bi bi-eye" /> Details </div>
//     )
//   };

  function onClickAdmin(ev) {
    ev.stopPropagation();
    history.push("/admin");
  }

  return (
    <div className="page admin-page">
      <div className="list-header sticky-page-header">
        <button className="new-button" onClick={onClickAdmin}>
          <i className="bi bi-chevron-left"/> Admin
        </button>
        <h1>User Audit Logs</h1>
        <i className="spacer" />
      </div>
      <div>
        <DataTable
          query="admin/user_audits"
          cols={table_columns}
          // actions={table_actions}
          empty="No Logs Found"
        />
      </div>
    </div>
  );
}
